import {DirectusTranslatedItem} from '@frontend/directus';
import {ProjectReference} from '../project-references.types';
import {ProjectReferenceFilter} from './project-references-filter.types';

export function createEmptyProjectReferenceFilter(): ProjectReferenceFilter {
  const filter: ProjectReferenceFilter = {
    searchText: '',
    industryIds: [],
    functionIds: [],
    countryCodes: [],
    languageCodes: [],
    minHeadcount: 0,
  };

  return filter;
}

export function matchesProjectReferenceFilter(
  reference: ProjectReference,
  filter: ProjectReferenceFilter,
): boolean {
  if (reference.id === null) {
    return true;
  }

  const industryIds: string[] = [requireIndustryId(reference)];
  const functionIds: string[] = reference.functionalScope.map((current) => current.functionId);

  return (
    matchesSearchText(reference, filter.searchText) &&
    matchesAnySelected(filter.industryIds, industryIds) &&
    matchesAnySelected(filter.functionIds, functionIds) &&
    matchesAnySelected(filter.countryCodes, reference.countryCodes) &&
    matchesAnySelected(filter.languageCodes, reference.languageCodes) &&
    requireHeadcount(reference) >= filter.minHeadcount
  );
}

export function toUsedOptions(
  options: DirectusTranslatedItem[],
  usedIds: string[],
): DirectusTranslatedItem[] {
  return options.filter((current) => usedIds.includes(current.id));
}

function requireIndustryId(reference: ProjectReference): string {
  if (reference.industryId === null) {
    throw new Error('A saved project reference must have an industry');
  }

  return reference.industryId;
}

function matchesSearchText(reference: ProjectReference, searchText: string): boolean {
  const search: string = searchText.trim().toLowerCase();

  return (
    search === '' ||
    reference.companyName.toLowerCase().includes(search) ||
    reference.projectName.toLowerCase().includes(search) ||
    reference.comment.toLowerCase().includes(search) ||
    reference.documentSummary.toLowerCase().includes(search)
  );
}

function matchesAnySelected(selectedIds: string[], referenceIds: string[]): boolean {
  return selectedIds.length === 0 || referenceIds.some((current) => selectedIds.includes(current));
}

function requireHeadcount(reference: ProjectReference): number {
  if (reference.headcount === null) {
    throw new Error('A saved project reference must have a headcount');
  }

  return reference.headcount;
}
